import { render, staticRenderFns } from "./RiskhubLogo.vue?vue&type=template&id=36d7737c&"
import script from "./RiskhubLogo.vue?vue&type=script&lang=js&"
export * from "./RiskhubLogo.vue?vue&type=script&lang=js&"
import style0 from "./RiskhubLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports